// ============================================================================
// ChatFab.jsx — butoni pluskues i asistentit, në pesë sjellje.
//
// 29 gusht 2026. Kërkesë e pronarit: «a mi jep disa verzione te butonit
// pluskus, te mund ta terhjeku, me largu nga rruga, te fshehet e shfaqet —
// disa versione do ishte mire per test».
//
// PSE NË SKEDAR TË VETIN. Çdo sjellje ka hook-at e vet (pozicion, orë, dëgjues).
// Po t'i shkruaja brenda `App.jsx`, do të ishin hook-a të kushtëzuar ose një
// varg i ri mbi një komponent që sot ka 554 sish — dhe sot e prishëm dy herë
// aplikacionin pikërisht me radhën e hook-ave (#310). Këtu komponenti montohet
// ose jo; brenda tij radha është gjithmonë e njëjtë.
//
// SJELLJET
//   fiks       rri gjithmonë në një vend (si sot)
//   terhiqes   e tërheq ku të duash; pozicioni mbahet për atë pajisje
//   fshihet    zhduket kur lëviz faqja, kthehet kur ndalon
//   buze       pas pak qetësie rrëshqet gjysmë jashtë skajit; prekja e kthen
//   mini       pas pak qetësie zvogëlohet në një pikë; prekja e rrit
//
// Të pesta e hapin të njëjtën bisedë. Asnjëra nuk krijon ekran të dytë.
// ============================================================================

import React, { useCallback, useEffect, useRef, useState } from "react";
import { SAFE_TOP, SAFE_BOTTOM } from "./zonaESigurt"; // kapaku 64/48 — shih shënimin atje

const QETESIA_MS = 2600;   // sa pritet para se «buze» dhe «mini» të tërhiqen
const PAS_LEVIZJES_MS = 900; // sa pas ndalimit të lëvizjes rikthehet «fshihet»
const KUJTESA = "pef_chat_fab_pos";

// Sa larg skajeve lejohet të shkojë kur tërhiqet. Pa këtë, një tërheqje e
// shpejtë e lë butonin gjysmë jashtë ekranit dhe njeriu s'e kap dot më.
const MARZH = 8;

function lexoPozicionin() {
  try {
    const raw = localStorage.getItem(KUJTESA);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (typeof p?.x !== "number" || typeof p?.y !== "number") return null;
    return p;
  } catch (_e) { return null; }
}

function shkruajPozicionin(p) {
  try { localStorage.setItem(KUJTESA, JSON.stringify(p)); }
  catch (_e) { /* dritare private — vlen vetëm për këtë seancë */ }
}

export default function ChatFab({
  sjellja = "fiks",
  onOpen,
  colors,
  etiketa = "Asistenti",
  ikona = null,
  // Sa lart nga fundi i ekranit, në piksel. E llogarit `App.jsx`, sepse vetëm
  // ai di çfarë ka poshtë: shiriti i telefonit, shiriti i pemës te desktopi, ose
  // asgjë. Më parë kjo ishte një çift klasash Tailwind (`bottom-20 lg:bottom-4`)
  // — dhe ato u shkruan kur desktopi s'kishte ende shirit poshtë. Sapo e mori,
  // butoni u ul saktësisht mbi të.
  poshte = 80,
}) {
  const [pos, setPos] = useState(() => lexoPozicionin());
  const [terheq, setTerheq] = useState(false);
  // «e qetë» = ka kaluar koha pa asnjë prekje; e përdorin `buze` dhe `mini`.
  const [qete, setQete] = useState(false);
  // «lëviz» = faqja po rrëshqet tani; e përdor `fshihet`.
  const [levizje, setLevizje] = useState(false);

  const ref = useRef(null);
  const nisja = useRef(null);
  const uTerhoq = useRef(false);
  const oraQetesise = useRef(null);
  const oraLevizjes = useRef(null);

  const zgjo = useCallback(() => {
    setQete(false);
    if (oraQetesise.current) clearTimeout(oraQetesise.current);
    oraQetesise.current = setTimeout(() => setQete(true), QETESIA_MS);
  }, []);

  // Ora e qetësisë vlen vetëm për dy sjelljet që tërhiqen vetë.
  useEffect(() => {
    if (sjellja !== "buze" && sjellja !== "mini") { setQete(false); return undefined; }
    zgjo();
    return () => { if (oraQetesise.current) clearTimeout(oraQetesise.current); };
  }, [sjellja, zgjo]);

  // Rrëshqitja e faqes. `capture: true` është i domosdoshëm: ngjarja `scroll`
  // nuk ngjitet lart, por gjatë kapjes kalon nga `document` — dhe te ky
  // aplikacion rrëshqet një kuti e brendshme, jo dritarja.
  useEffect(() => {
    if (sjellja !== "fshihet") { setLevizje(false); return undefined; }
    const h = () => {
      setLevizje(true);
      if (oraLevizjes.current) clearTimeout(oraLevizjes.current);
      oraLevizjes.current = setTimeout(() => setLevizje(false), PAS_LEVIZJES_MS);
    };
    document.addEventListener("scroll", h, true);
    return () => {
      document.removeEventListener("scroll", h, true);
      if (oraLevizjes.current) clearTimeout(oraLevizjes.current);
    };
  }, [sjellja]);

  // Prekja kudo e zgjon butonin e tërhequr. Pa këtë, «buze» dhe «mini» do të
  // ktheheshin vetëm duke i prekur ata vetë — dhe kur janë gjysmë jashtë
  // ekranit, pikërisht ajo është e vështira.
  useEffect(() => {
    if (sjellja !== "buze" && sjellja !== "mini") return undefined;
    const h = () => zgjo();
    document.addEventListener("pointerdown", h, true);
    document.addEventListener("scroll", h, true);
    return () => {
      document.removeEventListener("pointerdown", h, true);
      document.removeEventListener("scroll", h, true);
    };
  }, [sjellja, zgjo]);

  // Pas rrotullimit të ekranit një pozicion i ruajtur mund të bjerë jashtë.
  useEffect(() => {
    if (sjellja !== "terhiqes") return undefined;
    const h = () => setPos((p) => (p ? kufizo(p) : p));
    window.addEventListener("resize", h);
    window.addEventListener("orientationchange", h);
    return () => {
      window.removeEventListener("resize", h);
      window.removeEventListener("orientationchange", h);
    };
  }, [sjellja]);

  function kufizo(p) {
    const w = window.innerWidth || 360;
    const h = window.innerHeight || 640;
    const madh = ref.current?.offsetWidth || 48;
    return {
      x: Math.min(Math.max(p.x, MARZH), Math.max(MARZH, w - madh - MARZH)),
      y: Math.min(Math.max(p.y, MARZH), Math.max(MARZH, h - madh - MARZH)),
    };
  }

  const onPointerDown = (e) => {
    zgjo();
    if (sjellja !== "terhiqes") return;
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    uTerhoq.current = false;
    nisja.current = { dx: e.clientX - r.left, dy: e.clientY - r.top };
    setTerheq(true);
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_e) { /* pa kapje — vazhdon */ }
  };

  const onPointerMove = (e) => {
    if (!terheq || !nisja.current) return;
    const p = kufizo({ x: e.clientX - nisja.current.dx, y: e.clientY - nisja.current.dy });
    // Vetëm një lëvizje e vërtetë e anulon klikimin. Pa këtë prag, çdo dridhje
    // e gishtit do ta ndalonte hapjen e bisedës.
    if (Math.abs(e.movementX) + Math.abs(e.movementY) > 0) uTerhoq.current = true;
    setPos(p);
  };

  const onPointerUp = () => {
    if (!terheq) return;
    setTerheq(false);
    nisja.current = null;
    setPos((p) => {
      if (!p) return p;
      // Ngjitet te skaji më i afërt: një buton që rri në mes të ekranit mbulon
      // gjithmonë diçka, sado i vogël.
      const w = window.innerWidth || 360;
      const madh = ref.current?.offsetWidth || 48;
      const nëMajtas = p.x + madh / 2 < w / 2;
      const i = kufizo({ x: nëMajtas ? MARZH : w - madh - MARZH, y: p.y });
      shkruajPozicionin(i);
      return i;
    });
  };

  const hap = () => {
    // Pas një tërheqjeje, lëshimi i gishtit nuk duhet ta hapë bisedën.
    if (uTerhoq.current) { uTerhoq.current = false; return; }
    if ((sjellja === "buze" || sjellja === "mini") && qete) { zgjo(); return; }
    onOpen?.();
  };

  const madhesia = sjellja === "mini" && qete && !terheq ? 22 : 48;
  const fshehur = sjellja === "fshihet" && levizje;

  // Pozicioni: i tërhequri përdor koordinata; të tjerët rrinë poshtë-djathtas,
  // mbi çfarëdo që ndodhet nën ta — lartësinë e jep `poshte`, një vlerë e
  // vetme, jo dy klasa që s'e dinë njëra-tjetrën.
  const iTerhequr = sjellja === "terhiqes" && pos;
  const klasa = iTerhequr ? "fixed" : "fixed right-4";

  const stili = {
    zIndex: 60,
    ...(iTerhequr
      ? { left: pos.x, top: pos.y }
      : { bottom: `calc(${Math.max(0, Number(poshte) || 0)}px + ${SAFE_BOTTOM})` }),
    // «buze» rrëshqet gjysmë jashtë nga ana ku ndodhet.
    transform: sjellja === "buze" && qete && !terheq
      ? (iTerhequr && pos.x < (window.innerWidth || 360) / 2 ? "translateX(-46%)" : "translateX(46%)")
      : "none",
    opacity: fshehur ? 0 : (qete && (sjellja === "buze") ? 0.55 : 1),
    pointerEvents: fshehur ? "none" : "auto",
    transition: terheq ? "none" : "transform .22s ease, opacity .22s ease, width .18s ease, height .18s ease",
    touchAction: sjellja === "terhiqes" ? "none" : undefined,
  };

  return (
    <div ref={ref} className={klasa} style={stili}>
      <button
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        onClick={hap}
        aria-label={etiketa}
        title={etiketa}
        style={{
          width: madhesia, height: madhesia, borderRadius: 999,
          background: colors.gold, color: colors.bgDeep, border: "none",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 6px 18px rgba(0,0,0,.35)",
          cursor: sjellja === "terhiqes" ? (terheq ? "grabbing" : "grab") : "pointer",
          padding: 0,
        }}
      >
        {madhesia >= 40 ? ikona : null}
      </button>
    </div>
  );
}
